// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"animation-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M11.4102 2L14.4871 7.11275L20.3005 8.45913L16.3888 12.9654L16.9047 18.9102L11.4102 16.5825L5.91577 18.9102L6.43171 12.9654L2.52001 8.45913L8.33334 7.11275L11.4102 2Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M11.4102 2L14.4871 7.11275L20.3005 8.45913L16.3888 12.9654L16.9047 18.9102L11.4102 16.5825L5.91577 18.9102L6.43171 12.9654L2.52001 8.45913L8.33334 7.11275L11.4102 2Z","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M19.9591 22.3559L18.8984 21.2953M21.6778 16.2407L20.6172 15.1801M13.381 22.3559L12.3203 21.2953","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-animation-1')
export default class Animation1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'animation-1',
    }
  }
}
